module.exports = __webpack_public_path__ + "images/4a023a011ca8d32a58c9bf69cf130c9b-aars_xpo.png";